import type { SummaryStat } from '../InsightsSnapshot'
import type { SummaryMetricItem } from './SummaryMetrics'
import { formatNumber } from '../../utils'
import { formatDifference } from '../MetricDifference'

export function formatMetricValue(metric: SummaryMetricItem): string {
  if (metric.unit === 'percentage') return `${metric.value}%`
  return formatNumber(metric.value)
}

/**
 * Maps a live summary metric to the pre-formatted `SummaryStat` shape the
 * shareable snapshot renders. Shared by the "Share as Post" flow and the
 * Insights launch announcement so both format values and deltas identically.
 */
export function metricToStat(metric: SummaryMetricItem): SummaryStat {
  const label = metric.name ?? metric.displayName ?? metric.type
  const diff = metric.difference ?? 0
  const direction: 'up' | 'down' | null =
    diff > 0 ? 'up' : diff < 0 ? 'down' : null
  return {
    label,
    value: formatMetricValue(metric),
    differenceLabel:
      direction != null
        ? formatDifference(diff, metric.differenceMode ?? 'percentage')
        : undefined,
    differenceDirection: direction,
  }
}
